import { createAsyncThunk } from '@reduxjs/toolkit'
import Reply from './reply-model'
import { delete_reply, load_replys, store_reply } from './reply-service'

export const LoadReplysAsync = createAsyncThunk<any, any>(
  'composer/load/reply',
  async (params: { uid: string }) => {
    return await load_replys(params)
  },
)

export const CreateReplyAsync = createAsyncThunk<any, any>(
  'composer/create/reply',
  async (params: Reply) => {
    return await store_reply(params)
  },
)

export const DeleteReplyAsync = createAsyncThunk<any, any>(
  'composer/delete/reply',
  async (params) => {
    return await delete_reply(params)
  },
)
